/* Load closed desktop promotional panels on real navigation intent. Text
   navigation remains in the initial HTML; no analytics or cart state changes. */
(function () {
  'use strict';
  var requests = new Map();
  function request(section) {
    if (requests.has(section)) return requests.get(section);
    var url = new URL(location.pathname, location.origin);
    url.searchParams.set('section_id', section);
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 8000);
    var promise = fetch(url.href, { credentials: 'same-origin', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Navigation unavailable');
        return response.text();
      }).then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var root = parsed.getElementById('shopify-section-' + section);
        if (!root) throw new Error('Navigation section unavailable');
        return root;
      }).catch(function (error) {
        requests.delete(section);
        throw error;
      }).finally(function () { clearTimeout(timer); });
    requests.set(section, promise);
    return promise;
  }
  function load(panel) {
    if (panel.dataset.megamenuLoading === 'true') return;
    panel.dataset.megamenuLoading = 'true';
    var status = panel.querySelector('[data-megamenu-status]');
    if (status) { status.hidden = false; status.textContent = panel.dataset.loadingText; }
    request(panel.dataset.headerSection).then(function (root) {
      if (!panel.isConnected) return;
      var source = Array.from(root.querySelectorAll('[data-megamenu-content]')).find(function (candidate) {
        return candidate.dataset.megamenuContent === panel.dataset.megamenuContent &&
          !candidate.hasAttribute('data-megamenu-deferred');
      });
      if (!source) throw new Error('Navigation panel unavailable');
      panel.replaceChildren.apply(panel, Array.from(source.childNodes));
      panel.removeAttribute('data-megamenu-deferred');
      delete panel.dataset.megamenuLoading;
    }).catch(function () {
      delete panel.dataset.megamenuLoading;
      requests.delete(panel.dataset.headerSection);
      if (panel.isConnected && status) {
        status.hidden = false;
        status.textContent = panel.dataset.errorText;
      }
      // The collection link always works. A later hover, focus or click retries
      // the read-only section; failed fetches never synthesize a navigation.
    });
  }
  function intent(event) {
    if (!matchMedia('(min-width: 768px)').matches || !event.target.closest) return;
    var details = event.target.closest('.header-mega--menu');
    if (!details) return;
    var panel = details.querySelector('[data-megamenu-deferred]');
    if (panel) load(panel);
  }
  ['pointerover', 'focusin', 'click'].forEach(function (type) {
    document.addEventListener(type, intent, { capture: true, passive: true });
  });
})();
